import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { IonicModule } from '@ionic/angular';

import { ElectronicAccessoriesPageRoutingModule } from './electronic-accessories-routing.module';

import { ElectronicAccessoriesPage } from './electronic-accessories.page';
import { WebsiteHeaderComponent } from 'src/app/website-header/website-header/website-header.component';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    ElectronicAccessoriesPageRoutingModule
  ],
  declarations: [ElectronicAccessoriesPage,WebsiteHeaderComponent]
})
export class ElectronicAccessoriesPageModule {}
